import React from 'react';
import PropTypes from 'prop-types';
import CheckboxButton from 'components/buttons/CheckboxButton';

const TimeSeriesModalItem = ({ item, index, onChecked }) => {
  const handleChecked = e => {
    onChecked({ ...item, isActive: e.value }, index);
  };

  return (
    <CheckboxButton
      checked={item.isActive}
      title={item.label}
      onChange={handleChecked}
      hasTransparentBg
    />
  );
};

TimeSeriesModalItem.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired
  }).isRequired,
  index: PropTypes.number.isRequired,
  onChecked: PropTypes.func.isRequired
};

export default TimeSeriesModalItem;
